export enum PayrollStatus {
  PREPARATION = 'preparation',
  SUPPLEMENTS_DEFINITION = 'supplements_definition',
  UNDER_REVIEW = 'under_review',
  PAYROLL_CALCULATION = 'payroll_calculation',
  PAYMENT_PROCESSING = 'payment_processing',
  PAID = 'paid',
}

export enum PayrollPhase {
  SUPPLEMENTS_DEFINITION = 'supplements_definition',
  PAYROLL_CALCULATION = 'payroll_calculation',
  PAYMENT = 'payment',
}
